import {Extension} from '@tiptap/vue-2';

export const FontSize = Extension.create({
    name: 'FontSize',

    addOptions() {
        return {
            types: ['textStyle']
        };
    },

    addGlobalAttributes() {
        return [
            {
                types: this.options.types,
                attributes: {
                    fontSize: {
                        default: null,
                        parseHTML: element => {
                            const size = element.style.fontSize || null;
                            return size ? size.replace('px', '') : null;
                        },
                        renderHTML: attributes => {
                            if (!attributes.fontSize) {return {};}
                            return { style: `font-size: ${attributes.fontSize}px` };
                        }
                    }
                }
            }
        ];
    },

    addCommands() {
        return {
            setFontSize:
                size =>
                    ({ chain }) => {
                        return chain().focus().setMark('textStyle', { fontSize: size }).run();
                    },
            unsetFontSize:
                () =>
                    ({ chain }) => {
                        return chain().focus().setMark('textStyle', { fontSize: null }).run();
                    }
        };
    }
});
